import { ANIMATION_DURATION_IN_MILLIS } from "components/Message/configs";
import { ENFORCER_PRODUCT_ID } from "configs/demonstration";
import useResizeObserver from "hooks/useResizeObserver";
import MessageProvider from "providers/MessageProvider";
import React, { useCallback, useRef, useState } from "react";
import { breakpoints } from "theme/breakpoints";
import Prompt from "./Prompt";
import { Container, StyledMessageForm } from "./styles";

const Message: React.FC = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isFormSuccessVisible, setIsFormSuccessVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const promptRef = useRef<HTMLDivElement>(null);
  const formRef = useRef<HTMLDivElement>(null);

  const onResizeHandler = useCallback(
    (element: Element) => {
      if (isFormVisible || !containerRef.current) {
        return;
      }

      containerRef.current.style.maxHeight = `${element.clientHeight}px`;
    },
    [isFormVisible]
  );

  useResizeObserver(promptRef, onResizeHandler);

  const onShowForm = () => {
    setIsFormVisible(true);

    if (!containerRef.current || !promptRef.current || !formRef.current) {
      return;
    }

    const targetHeight =
      window.innerWidth <= parseInt(breakpoints.lg, 10)
        ? formRef.current.clientHeight + promptRef.current.clientHeight
        : formRef.current.clientHeight;

    containerRef.current.style.maxHeight = `${targetHeight}px`;

    setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.style.maxHeight = "none";
      }
    }, ANIMATION_DURATION_IN_MILLIS);
  };

  const onHideForm = () => {
    setIsFormVisible(false);

    if (!containerRef.current || !promptRef.current) {
      return;
    }

    containerRef.current.style.maxHeight = `${containerRef.current.clientHeight}px`;
    containerRef.current.style.maxHeight = `${promptRef.current.clientHeight}px`;
  };

  const onFormSuccess = () => {
    onHideForm();
    setIsFormSuccessVisible(true);
  };

  const onResetPrompt = () => setIsFormSuccessVisible(false);

  return (
    <MessageProvider
      isFormVisible={isFormVisible}
      isFormSuccessVisible={isFormSuccessVisible}
      onShowForm={onShowForm}
      onResetPrompt={onResetPrompt}
    >
      <Container ref={containerRef} isFormVisible={isFormVisible}>
        <Prompt ref={promptRef} />
        <StyledMessageForm
          ref={formRef}
          onCancel={onHideForm}
          onSuccess={onFormSuccess}
          productId={ENFORCER_PRODUCT_ID}
        />
      </Container>
    </MessageProvider>
  );
};

export default Message;
